import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { Wrapper as PillWrapper } from '@spa/shared/components/Unisystem/Pill/styles';
import { Wrapper as CarouselOverallWrapper, Header } from '@spa/shared/components/SimpleCarousel/styles';
import { TooltipContainer } from '@spa/shared/components/Tooltip/styles';
import { mediaMin } from '@spa/shared/theme';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-rf4wwr-0"
})(["display:flex;flex-direction:column;", " color:", ";width:100%;", "{", " ", "{p{font-size:", ";line-height:", ";font-weight:400;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
}, function (props) {
  return props.theme.landlordSection.textColor;
}, CarouselOverallWrapper, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6, 'column');
}, Header, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
export var Title = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-rf4wwr-1"
})(["display:flex;", " align-items:flex-start;flex-wrap:wrap;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;}& > span{display:flex;align-items:center;flex-wrap:wrap;", " ", "{", "}}", "{font-size:", ";line-height:", ";color:", ";padding:", " ", ";height:32px;svg{path{fill:", ";}}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(3);
}, TooltipContainer, mediaMin.smallBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        min-width: 180px;\n        max-width: 180px;\n      "]))), PillWrapper, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
});
export var LandlordStats = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-rf4wwr-2"
})(["display:flex;", " flex-wrap:wrap;div{display:flex;", " align-items:center;svg{width:24px;height:24px;}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(4);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.gap(2);
});